// extracted by mini-css-extract-plugin
export default {"modalWidth":"CalibrationSettingsModal_modalWidth__dWW1l","periodLable":"CalibrationSettingsModal_periodLable__hae9s","repeatNumber":"CalibrationSettingsModal_repeatNumber__oVJq8"};